export const DEFAULT_API_ERROR = "Something Went Wrong"

export const CHALLENGES_USER_RESULT_STATUS = {
  OPEN: 'open',
  REJECTED: 'rejected',
  ACCEPTED: 'accepted',
};